import {Injectable, signal} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {
  REF_MODEL_STORE,
  RefModelNode,
  RefModelStoreService,
  SnackBarService,
  TakeUntilComponentDestroy
} from '@q9elements/ui-kit/common';
import {DependenciesService, NodeAttachDialogComponent} from '@q9elements/ui-kit/refmodels';
import {combineLatest} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';

@Injectable()
export class AttachNodeService extends TakeUntilComponentDestroy {
  readonly q9canPasteOrgNode = signal<boolean | null>(null);
  readonly q9canPasteRefNode = signal<boolean | null>(null);

  constructor(
    public dependenciesService: DependenciesService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
    private rmeStore: RefModelStoreService
  ) {
    super();
  }

  public checkCanPasteNode(): void {
    combineLatest([
      this.rmeStore.select(REF_MODEL_STORE.CAN_PASTE_ORG_NODE),
      this.rmeStore.select(REF_MODEL_STORE.CAN_PASTE_REF_NODE)
    ])
      .pipe(this.takeUntilComponentDestroy())
      .subscribe(([org, ref]) => {
        this.q9canPasteOrgNode.set(org as boolean);
        this.q9canPasteRefNode.set(ref as boolean);
      });
  }

  public getNodeFromCookie(key: string) {
    return this.dependenciesService.refModelSidebarService.getNodeFromCookie(key);
  }

  public pasteDependency(data: any): void {
    const {refModelId, nodeId, copiedNode, selectedNode} = data;

    if (nodeId === copiedNode._id) {
      this.snackBarService.error('NOTIFICATIONS.PASTE_NODE_ERROR');
      return;
    }

    this.openNodeAttachDialog(copiedNode, selectedNode!)
      .pipe(
        filter(Boolean),
        switchMap(() => this.dependenciesService.getDependenciesByNode(refModelId, nodeId, 0, 20)),
        this.takeUntilComponentDestroy()
      )
      .subscribe({
        error: err => this.snackBarService.open(err)
      });
  }

  private openNodeAttachDialog(cookieData: RefModelNode, node: RefModelNode) {
    return this.dialog
      .open(NodeAttachDialogComponent, {
        width: '600px',
        data: {
          isEdit: false,
          deps: cookieData,
          node
        }
      })
      .afterClosed();
  }

  public copyNode() {
    this.dependenciesService.refModelSidebarService.copyNodeLink();
  }
}
